import { getCanDeleteSection, getCanHideSection, sectionHasBlogRssModule as getSectionHasBlogRssModule, sectionHasWebversionAndIsVariant as getSectionHasWebversionAndIsVariant } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { getCanSaveLayouts, getPortalHasSavedLayouts } from 'EmailEditorUI/redux/selectors/AuthSelectors';
// @ts-expect-error Could not find a declaration file for module ...
import { getIsSingleColumnFullWidth } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getSectionOptionsKeys = basicSelector((state, section) => {
  const isSingleColumnFullWidth = getIsSingleColumnFullWidth(state);
  const portalHasSavedLayouts = getPortalHasSavedLayouts(state);
  const canSaveLayouts = getCanSaveLayouts(state);
  const canDeleteSection = getCanDeleteSection(state, section);
  const canHideSection = getCanHideSection(state, section);
  const sectionHasBlogRssModule = getSectionHasBlogRssModule(state, section);
  const sectionHasWebversionAndIsVariant = getSectionHasWebversionAndIsVariant(state, section);
  const disabled = !canDeleteSection || isSingleColumnFullWidth;
  let cloneMessage = 'email-editor-ui-shared.layoutBuilder.sections.clone';
  let removeMessage = 'email-editor-ui-shared.layoutBuilder.sections.remove';
  let hideMessage = 'email-editor-ui-shared.layoutBuilder.sections.hideDisabled.undeletableFooterModule';
  if (isSingleColumnFullWidth) {
    cloneMessage = 'email-editor-ui-shared.layoutBuilder.sections.cloneDisabledFullWidth';
    removeMessage = 'email-editor-ui-shared.layoutBuilder.sections.removeDisabledFullWidth';
  } else {
    if (disabled) {
      if (!canHideSection && !sectionHasBlogRssModule && !sectionHasWebversionAndIsVariant) {
        cloneMessage = 'email-editor-ui-shared.layoutBuilder.sections.cloneDisabled.undeletableFooterModule';
        removeMessage = 'email-editor-ui-shared.layoutBuilder.sections.removeDisabled.undeletableFooterModule';
        hideMessage = 'email-editor-ui-shared.layoutBuilder.sections.hideDisabled.undeletableFooterModule';
      } else if (sectionHasBlogRssModule && canHideSection && !sectionHasWebversionAndIsVariant) {
        cloneMessage = 'email-editor-ui-shared.layoutBuilder.sections.cloneDisabled.undeletableBlogModule';
        removeMessage = 'email-editor-ui-shared.layoutBuilder.sections.removeDisabled.undeletableBlogModule';
        hideMessage = 'email-editor-ui-shared.layoutBuilder.sections.hideDisabled.undeletableBlogModule';
      } else if (sectionHasWebversionAndIsVariant && !sectionHasBlogRssModule && canHideSection) {
        cloneMessage = 'email-editor-ui-shared.layoutBuilder.sections.cloneDisabled.undeletableWebversionModule';
        removeMessage = 'email-editor-ui-shared.layoutBuilder.sections.removeDisabled.undeletableWebversionModule';
        hideMessage = 'email-editor-ui-shared.layoutBuilder.sections.hideDisabled.undeletableWebversionModule';
      } else if (!canHideSection && sectionHasBlogRssModule && !sectionHasWebversionAndIsVariant) {
        cloneMessage = 'email-editor-ui-shared.layoutBuilder.sections.cloneDisabled.undeletableFooterAndBlogModule';
        removeMessage = 'email-editor-ui-shared.layoutBuilder.sections.removeDisabled.undeletableFooterAndBlogModule';
        hideMessage = 'email-editor-ui-shared.layoutBuilder.sections.hideDisabled.undeletableFooterAndBlogModule';
      } else if (!canHideSection && !sectionHasBlogRssModule && sectionHasWebversionAndIsVariant) {
        cloneMessage = 'email-editor-ui-shared.layoutBuilder.sections.cloneDisabled.undeletableFooterAndWebVersionModule';
        removeMessage = 'email-editor-ui-shared.layoutBuilder.sections.removeDisabled.undeletableFooterAndWebVersionModule';
        hideMessage = 'email-editor-ui-shared.layoutBuilder.sections.hideDisabled.undeletableFooterAndWebVersionModule';
      } else if (canHideSection && sectionHasBlogRssModule && sectionHasWebversionAndIsVariant) {
        cloneMessage = 'email-editor-ui-shared.layoutBuilder.sections.cloneDisabled.undeletableBlogAndWebVersionModule';
        removeMessage = 'email-editor-ui-shared.layoutBuilder.sections.removeDisabled.undeletableBlogAndWebVersionModule';
        hideMessage = 'email-editor-ui-shared.layoutBuilder.sections.hideDisabled.undeletableBlogAndWebVersionModule';
      } else if (!canHideSection && sectionHasBlogRssModule && sectionHasWebversionAndIsVariant) {
        cloneMessage = 'email-editor-ui-shared.layoutBuilder.sections.cloneDisabled.undeletableFooterAndBlogAndWebVersionModule';
        removeMessage = 'email-editor-ui-shared.layoutBuilder.sections.removeDisabled.undeletableFooterAndBlogAndWebVersionModule';
        hideMessage = 'email-editor-ui-shared.layoutBuilder.sections.hideDisabled.undeletableFooterAndBlogAndWebVersionModule';
      }
    }
  }
  let saveMessage = 'email-editor-ui-shared.layoutBuilder.sections.saveSection';
  if (portalHasSavedLayouts) {
    if (!canSaveLayouts) {
      saveMessage = 'email-editor-ui-shared.layoutBuilder.sections.saveDisabledPermission';
    } else if (sectionHasBlogRssModule) {
      saveMessage = 'email-editor-ui-shared.layoutBuilder.sections.saveDisabledBlogRss';
    }
  }
  return {
    cloneMessage,
    disabled,
    removeMessage,
    hideMessage,
    saveMessage
  };
});